import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {notification, Radio, Space} from "antd";
import classes from "@/app/[locale]/(main)/calendar/components/dispute-popup/DisputePopup.module.scss";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import TextArea from "antd/es/input/TextArea";
import {getCookie} from "cookies-next";


function DisputePopup({setUnreadNotifications, closeModal, closeFirstModal, data}) {
    const {t} = useTranslation();

    const [value, setValue] = useState();
    const [textValue, setTextValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [api, contextHolder] = notification.useNotification();

    const openNotification = (type, placement, text) => {
        api[type]({
            message: `${type === 'error' ? t('notifications.error') : t('notifications.success')}`,
            description: text,
            placement,
        });
    };
    const onChange = (e) => {
        setValue(e.target.value);
        let text;
        switch (e.target.value) {
            case 1:
                text = t('modal.disputeReason1');
                break;
            case 2:
                text = t('modal.disputeReason2');
                break;
            case 3:
                text = t('modal.other');
                break;
            default:
                text = '';
        }
        setTextValue(text)
    };
     async function sendDispute(values) {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/open-dispute`, {
            method: 'POST', headers: {
                'Content-Type': 'application/json', 'Authorization': `Bearer ${getCookie('jwt')}`,
            }, body: JSON.stringify(values),
        });
        const data = await res.json();
        return {status:res.status,message:data.message};
    }

    const submitDispute = () => {
        setLoading(true);

        sendDispute({reason: textValue, meeting_id: data.meeting_id}).then((res) => {
            if (res.status >= 200 && res.status <= 299) {
                if (setUnreadNotifications) {
                    openNotification('success', 'bottomRight', t('notifications.disputeSent'))
                    if (setUnreadNotifications) {
                        setTimeout(() => {
                            setUnreadNotifications((prevNotifications) => prevNotifications.filter(notification => notification.meeting_id !== data.meeting_id));
                        }, 1000)
                    }
                    setLoading(false);
                }else {
                    openNotification('success', 'bottomRight', t('notifications.disputeSent'))
                    setLoading(false);
                    setTimeout(() => {
                        if (closeFirstModal) {
                            closeFirstModal();
                        }
                        closeModal();
                    },1000)

                }
            } else if(res.status === 401 || res.status === 403 || res.status === 422) {
                openNotification('error', 'bottomRight', res.message)
                setLoading(false);
            }else {
                openNotification('error', 'bottomRight', t('notifications.serverError'))
                setLoading(false);
            }
        }).catch((err) => {
            openNotification('error', 'bottomRight', t('notifications.serverError'))
            setLoading(false);
        })
    }

    return (<div className={classes.dispute}>
        {contextHolder}
        <h3>{t('modal.dispute')}</h3>
        <Radio.Group disabled={false} onChange={onChange} value={value}>
            <Radio value={1}>{t('modal.disputeReason1')}</Radio>
            <Radio value={2}>{t('modal.disputeReason2')}</Radio>
            <Radio value={3}>
                {t('modal.other')}
            </Radio>
        </Radio.Group>
        {value === 3 && <TextArea
            placeholder={t('modal.reason')}
            disabled={false}
            rootClassName={classes.text}
            onChange={(e) => setTextValue(e.target.value)}
        />}
        <div className={classes.footer}>
            <span className={loading && classes.disabled} onClick={() => closeModal()}>{t('modal.back')}</span>
            <RoundedButton loading={loading} onClick={submitDispute} disabled={!value} type="primary"
                           htmlType="submit">
                {t('buttons.sendDispute')}
            </RoundedButton>
        </div>
    </div>);
}

export default DisputePopup;